import { Controller } from '../utils/controller';

export default class extends Controller {
  static values = {
    businessUnitId: {
      type: String,
      default: ''
    },
    environment: {
      type: String,
      default: ''
    }
  };

  declare businessUnitIdValue: string;
  declare environmentValue: string;

  connect() {
    this.init();
  }

  private init() {
    const buid = this.businessUnitIdValue;
    const env = this.environmentValue;

    if (buid && env) {
      window.LiveChat = window.LiveChat || {};
      window.LiveChat.businessUnitId = buid;
      window.LiveChat.environment = env;
      // @ts-expect-error Dynamic import
      import('../../vendor/livechat-init.min');
    }
  }
}
